<div class="grid w-full">
  <div class="col-12">
    <header class="bg-primary p-2">
      <img src="assets/SACS_combomark_rev.1_light.png" class="h-3rem" alt="SACS Data Viewer">
    </header>
    <section class="h-2rem border-bottom-1 border-cyan-500"></section>
    <section class="pt-1 pl-5"><app-messages></app-messages></section>
    <section class="pl-5 pr-5 pb-0"><app-news-announcements></app-news-announcements></section>
    <section role="main" class="pl-5">
      <h1 id="dataViewerHeader" class="pb-0 m-0">
        <span id="dataViewerLabel" class="font-bold text-3xl">SACS Data Viewer</span>
        <help-link [path]="helpUrl"></help-link>
      </h1>
      <h2 class="pt-0 mt-0">
          <div class="text-l font-normal">
            Financial reports of local educational agencies serving California public school students.
          </div>
      </h2>
    </section>
  </div>
</div>

<div role="search" class="sub-frame">
  <div class="grid w-full pl-5 pr-5 pb-0">
    <div class="col-12">
      <app-data-explorer-filter #filter
        [loadingFiscalYears]="loadingFiscalYears"
        [fiscalYearOptions]="fiscalYearOptions"
        [loadingReportingPeriods]="loadingReportingPeriods"
        [reportingPeriodOptions]="reportingPeriodOptions"
        [loadingEntityTypes]="loadingEntityTypes"
        [entityTypeOptions]="entityTypeOptions"
        [loadingEntities]="loadingEntities"
        [rollupDataExtract]="rollupDataExtract"
        [rollupDatImport]="rollupDatImport"
        (fiscalYearChangeEvent)="fiscalYearChange($event)"
        (reportingPeriodChangeEvent)="reportingPeriodChange()"
        (applyFiltersEvent)="applyFilters($event)"
        (downloadRollupBlobEvent)="downloadRollupArtifactBlob($event)"></app-data-explorer-filter>
    </div>

    <div *ngIf="filteredEntityType && filteredEntityType === entityType.CountyOfficeOfEducation" class="col-12 mt-0">
      <label class="flex text-xl text-700">Files below are for the county office of education.</label>
    </div>

    <div class="col-12">
      <div class="p-0 m-0">
        <div class="grid w-full p-0 m-0 align-items-end">
          <div class="field col-12 md:col-6 lg:col-11 p-0 m-0">
            <label class="flex text-xl text-700">Available Records</label>
          </div>
          <div class="col-12 md:col-6 lg:col-1 flex justify-content-end p-0 m-0">
            <p-button type="button" label="Download all" ariaLabel="download all" [disabled]="!downloadAllArtifact"
                      styleClass="p-button-outlined p-button-primary mb-2" icon="pi pi-file"
                      (onClick)="downloadSubmissionArtifactBlob(downloadAllArtifact)">
            </p-button>
          </div>
        </div>
      </div>
      <div class="p-0 m-0">
        <div class="col-12 m-0 p-0">
          <app-grid #grid
                    tableId="dataExplorerTable"
                    [colSelectId]="'selectColumns'"
                    [resetFilterId]="'resetFilter'"
                    [data]="data"
                    [cols]="cols"
                    [loading]="loading || exporting || importing"
                    [lazy]="true"
                    (lazyLoad)="lazyLoadData($event)"
                    [lazyLoadOnInit]="false"
                    [selectedColumns]="selectedColumns"
                    [availableColumns]="availableColumns"
                    (showFilter)="showFilter($event)"
                    [globalFilterFields]="globalFilterFields"
                    [multiSortMeta]="multiSortMeta"
                    [totalRecords]="totalRecords"
                    [showCaption]="false"
                    [paginator]="true"
                    [totalColumns]="cols.length + 2"
                    [zeroRecordsFoundMessage]="totalRecords === 0 ? entityHasNotSubmittedDataInfoMessage.text : null"
                    styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-hoverable-rows p-datatable-responsive">

            <ng-template pTemplate="headerRowContentSuffix">
              <th role="columnheader" class="column-delete frozen-vertical " style="vertical-align: top">
                <div class="flex justify-content-between align-content-start flex-column">
                  <span class="align-items-end pt-0" id="downloadFormatLabel">Downloads</span>
                </div>
              </th>
            </ng-template>
            <ng-template pTemplate="bodyRowContentSuffix" let-rowData="rowData">
              <td class="w-5rem">
                <p-button id="Data__{{rowData.id}}_DownloadBlobButton"
                          styleClass="p-button-primary mr-1"
                          [icon]="rowData.icon"
                          [loading]="rowData.loading"
                          [disabled]="rowData.loading"
                          [label]="rowData.label"
                          [ariaLabel]="rowData.ariaLabel"
                          type="button"
                          icon="pi pi-file" (onClick)="downloadSubmissionArtifactBlob(rowData)"></p-button>
              </td>
            </ng-template>
          </app-grid>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Captcha" [(visible)]="displayModal && !captchaDisabled" [modal]="true" [style]="{width: '10vw'}" [draggable]="false" [resizable]="false" [closable]="false">
  <div>
    <ngx-turnstile *ngIf="displayModal && !captchaDisabled" [siteKey]="captchaSiteKey" theme="light" (resolved)="captchaResolved($event)"></ngx-turnstile>
  </div>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-times" (click)="displayModal=false" label="Cancel" styleClass="p-button-text"></p-button>
  </ng-template>
</p-dialog>